/* <!-- DYGAMING: javascript for sidebar --> */
/* NOTE: CODE HERE GETS EXECUTED GLOBALLY. SCOPE YOUR DECLARATIONS */

(function() {
  
  /* auto-update sidebar nav when menu is clicked */
  function updateSidebarNav(event) {
    var sport = event.target.getAttribute('data-sport');
    var subLinks = document.querySelectorAll('.sidebar-cell-sub[data-sport="' + sport + '"]');
    var masterLink = document.querySelector('.sidebar-cell[data-sport="' + sport + '"]');
    
    subLinks.forEach(function(subLink) {
      if (subLink.classList.contains('active')) {
        subLink.classList.remove('active');
        masterLink.classList.remove('active');
      }
      else {
      	subLink.classList.add('active'); 
        masterLink.classList.add('active');
      }
    });
  }
  
  /* add the event listener on first page load */
  document.querySelectorAll('.sidebar-cell').forEach(function(masterLink) {
    masterLink.addEventListener('click', updateSidebarNav);
  });
  
  /* run on PLP and PDP page load, using a hack to pretend its a click event */
  if (seDataLayer.pageType.includes('collection') || seDataLayer.pageType.includes('product')) {
    var dummyTarget = document.createElement('div');
    dummyTarget.setAttribute('data-sport', seDataLayer.productCategory.toLowerCase())
    updateSidebarNav({target: dummyTarget});
  }
  
  /* Insert hidden element to add to page when all scripts are done loading */
  var gamingReadyDiv = document.createElement('div');
  gamingReadyDiv.id = "dy-gaming-ready";
  gamingReadyDiv.style.display = 'none';
  document.querySelector('body').append(gamingReadyDiv);
})();